import { bootstrapShell } from "@icapitalnetwork/shell";

bootstrapShell(
  [
    "/apps/shell/latest/manifest.json",
    "/apps/shell/latest/importmap.vendors.json",
    {
      manifest: {
        "unified-sitenav": {
          preload: false,
        },
      },
    },
  ],
  {
    // eslint-disable-next-line no-restricted-globals
    devMode: import.meta.env.DEV || location.pathname.startsWith("/apps"),
  },
)
  .then((loadModule) => {
    if (import.meta.env.DEV) {
      loadModule("/src/main.js");
    } else {
      // Compiled ES module has .es.js extension as configured in vite.config.es.ts, so we need to load that one instead of main.js
      loadModule("./main.es.js");
    }
  })
  .catch((error) => {
    console.error("Error bootstrapping the shell:", error);
  });
